import dynamic from 'next/dynamic';
import type { LightboxProps } from './Lightbox/types';

export const ZoomDialog = dynamic<LightboxProps>(
  () => import(/* webpackChunkName: 'ZoomDialog' */ './Lightbox').then((module) => module.Lightbox),
  { ssr: false },
);
